import React, { useState } from "react";
import Content from "../../../../layout/content/Content";
import Head from "../../../../layout/head/Head";

import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  LoadingComponent,
  PreviewCard,
  ReactDataTable,
  StatusActiveDropDown,
} from "../../../../components/Component";
import AddUser from "./AddUser";
import { listUserAPI, userDataTableColumns } from "./UserData";
import { useEffect } from "react";
import { PER_PAGE_ITEMS, ServerStatusType } from "../../../../utils";
import { ImportExportButton } from "../../../../components/button/ActionButton";
import {
  UserActionType,
  UserPermissionType,
  isAllowToAccess,
  isCheckToList,
} from "../../../../services/permission/permission";
import { scrollToTop } from "../../../../utils/Functions";

const UserList = () => {
  const [userListData, setUserListData] = useState([]);
  const [status, setStatus] = useState();
  const [searchText, setSearchText] = useState("");
  const [modal, setModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [initScreen, setInitScreen] = useState(true);
  const [totalItems, setTotalItems] = useState(0);
  const [sortId, setSortId] = useState();
  const [sortOrder, setSortOrder] = useState("asc");

  useEffect(() => {
    loadUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  useEffect(() => {
    if (initScreen) return;
    if (currentPage === 1) {
      loadUsers();
    } else {
      setCurrentPage(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, searchText, sortId, sortOrder]);

  const onEdit = (row) => {
    setSelectedItem(row);
    setModal(true);
  };

  function loadUsers() {
    scrollToTop();
    if (isCheckToList(UserPermissionType.user)) {
      listUserAPI(
        {
          pageInfo: {
            pageIndex: currentPage,
            itemsPerPage: PER_PAGE_ITEMS,
          },
          sorting: {
            field: sortId ?? null,
            order: sortOrder ?? null,
          },
          status: status?.value ?? ServerStatusType.active,
          search: searchText,
        },
        (data, error) => {
          if (error === null) {
            setUserListData(data.list);
            if (currentPage === 1) {
              setTotalItems(data?.pageInfo?.totalItems ?? 0);
            }
          }
          setInitScreen(false);
        }
      );
    } else {
      setInitScreen(false);
    }
  }

  return (
    <React.Fragment>
      <Head title="Users" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween className="flex-wrap">
            <BlockHeadContent>
              <BlockTitle page>User</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent className="ms-auto">
              <div className="d-flex align-items-center flex-wrap">
                <span className="p-1">
                  <input
                    className="form-control"
                    type="text"
                    name="search"
                    value={searchText}
                    placeholder="Search"
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                  />
                </span>
                <span className="p-1">
                  <StatusActiveDropDown
                    value={status}
                    className="w-100px "
                    onSelect={(e) => {
                      setStatus(e);
                    }}
                  />
                </span>
                {isAllowToAccess(UserPermissionType.user, UserActionType.add) && (
                  <span className="ps-1">
                    <ImportExportButton addButton title={"Add"} onClick={() => setModal(true)} iconName={"plus"} />
                  </span>
                )}
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewCard>
            <ReactDataTable
              data={userListData}
              columns={userDataTableColumns(onEdit)}
              isAllowed={isCheckToList(UserPermissionType.user)}
              totalItemCount={totalItems}
              pagination
              onPageChanged={(page, count) => {
                setCurrentPage(page);
              }}
              onSort={(id) => {
                setSortId(id);
                const newSortOrder = sortOrder === "desc" ? "asc" : "desc";
                setSortOrder(newSortOrder);
              }}
            />
          </PreviewCard>
        </Block>
        <AddUser
          visible={modal}
          item={selectedItem}
          onClosed={() => {
            setModal(false);
            setSelectedItem();
          }}
          onSaved={() => {
            loadUsers();
          }}
        />
        <LoadingComponent isLoading={initScreen} />
      </Content>
    </React.Fragment>
  );
};

export default UserList;
